// ─────────────────────────────────────────────────────────────────────────────
// 🔑 WHEN THE CLOSING DISCLOSURE PAGE (re)LOADS ITS PDF (2026-11-03). The load effect was keyed on data?.cd_signed,
// which goes undefined → false when /api/closing/status answers, so every visit fetched the PDF twice. The key is now:
//   · null while the status is still loading (wait: one load, with the signed state known);
//   · 'signed' / 'unsigned' once it has answered — the reload after signing (the signed copy) still happens;
//   · 'unknown' if the status call failed, so the PDF still loads once.
// ─────────────────────────────────────────────────────────────────────────────
export function cdPdfLoadKey(data, statusLoading) {
  if (data) return data.cd_signed ? 'signed' : 'unsigned';
  return statusLoading ? null : 'unknown';
}
